import { render, staticRenderFns } from "./HeadbarPage.vue?vue&type=template&id=1f646f1b"
import script from "./HeadbarPage.vue?vue&type=script&lang=js"
export * from "./HeadbarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports